'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultStyles = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _templateObject = _taggedTemplateLiteral(['\n  width: 100%;\n  padding-bottom: 56.25%;\n  background-position: center center;\n  background-size: cover;\n'], ['\n  width: 100%;\n  padding-bottom: 56.25%;\n  background-position: center center;\n  background-size: cover;\n']);

exports.YouTubeGetID = YouTubeGetID;
exports.YoutubeThumbnailComponent = YoutubeThumbnailComponent;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _bduiStyles = require('@bd/bdui-styles');

var _bduiStyles2 = _interopRequireDefault(_bduiStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function YouTubeGetID(url) {
  var ID = '';
  var newUrl = url.replace(/(>|<)/gi, '').split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/);

  if (newUrl[2] !== undefined) {
    var _newUrl$2$split = newUrl[2].split(/[^0-9a-z_-]/i);

    var _newUrl$2$split2 = _slicedToArray(_newUrl$2$split, 1);

    ID = _newUrl$2$split2[0];
  } else {
    ID = newUrl;
  }

  return ID;
}

var defaultStyles = exports.defaultStyles = (0, _bduiStyles.css)(_templateObject);

function YoutubeThumbnailComponent(_ref) {
  var ariaLabel = _ref.ariaLabel,
      className = _ref.className,
      index = _ref.index,
      onClick = _ref.onClick,
      video = _ref.video;

  var url = 'https://img.youtube.com/vi/' + YouTubeGetID(video) + '/hqdefault.jpg';

  if (typeof onClick === 'function') {
    return _react2.default.createElement('div', {
      'aria-label': ariaLabel,
      role: 'button',
      tabIndex: 0,
      className: className,
      style: {
        backgroundImage: 'url(\'' + url + '\')'
      },
      'data-index': index,
      onClick: onClick
    });
  }

  return _react2.default.createElement('div', {
    className: className,
    style: {
      backgroundImage: 'url(\'' + url + '\')'
    },
    'data-index': index
  });
}

YoutubeThumbnailComponent.propTypes = {
  ariaLabel: _propTypes2.default.string,
  className: _propTypes2.default.string,
  index: _propTypes2.default.number,
  onClick: _propTypes2.default.func,
  video: _propTypes2.default.string.isRequired
};

YoutubeThumbnailComponent.defaultProps = {
  ariaLabel: undefined,
  className: undefined,
  index: undefined,
  onClick: undefined
};

exports.default = (0, _bduiStyles2.default)(defaultStyles)(YoutubeThumbnailComponent);


//////////////////
// WEBPACK FOOTER
// ./~/@bd/bdui-youtubethumbnail/build/YoutubeThumbnail.js
// module id = 1286
// module chunks = 0